module.exports = {"region":"us-east-1","userPool":"us-east-1_CXZRq4he1","identityPool":"us-east-1:52f6a0c3-dc26-4ff4-a2c2-781619c7dc12","clientId":"58uv82u0gj1d95ekcls3opkbu7"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 354
// module chunks = 0